import { App as AntdApp } from "antd";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import FanPage from "@pages/FanPage";
import { ThemeProvider } from "@providers/ThemeProvider";
import { ReduxProvider } from "@providers/ReduxProvider";
import { AdapterProvider } from "@adapters";
import { AuthGuard } from "@components/AuthGuard";
import { NotificationProvider } from "@providers/NotificationProvider";
import { ROUTES } from "@config/routes.config";

const AppContent = () => {
  return (
    <AuthGuard>
      <div className="app-shell">
        <Routes>
          <Route path={ROUTES.HOME} element={<FanPage isShowInfoUser={true} />} />
          <Route path={ROUTES.CHAT} element={<FanPage isShowInfoUser={true} />} />
          <Route path="/conversations" element={<FanPage isShowInfoUser={true} />} />
          <Route path="/conversations/:platform/:pageId/:conversationId" element={<FanPage isShowInfoUser={true} />} />
          <Route path="/conversations/:conversationId" element={<FanPage isShowInfoUser={true} />} />
          <Route path="/settings/*" element={<FanPage isShowInfoUser={true} />} />
          <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
        </Routes>
      </div>
    </AuthGuard>
  );
};

const App = () => (
  <BrowserRouter>
    <ReduxProvider>
      <AdapterProvider>
        <ThemeProvider>
          <AntdApp>
            <NotificationProvider placement="topRight">
              <AppContent />
            </NotificationProvider>
          </AntdApp>
        </ThemeProvider>
      </AdapterProvider>
    </ReduxProvider>
  </BrowserRouter>
);

export default App;
